import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class MOServices {
  createMO = async (payload) => {
    const mo = await Helpers.post({
      url: Constants.MO,
      data: payload,
    });
    return mo;
  }

  createMOAdjustment = async (payload) => {
    const moAdjustment = await Helpers.post({
      url: Constants.MO_ADJUSTMENT,
      data: payload,
    });
    return moAdjustment;
  }

  createMOAdjustmentV2 = async (payload) => {
    const moAdjustment = await Helpers.post({
      url: Constants.MO_ADJUSTMENT_V2,
      data: payload,
    });
    return moAdjustment;
  }

  updateMO = async (payload) => {
    const mo = await Helpers.put({
      url: Constants.MO,
      data: payload,
    });
    return mo;
  }

  updateMOOtherCharges = async (payload) => {
    const moOtherCharges = await Helpers.put({
      url: Constants.MO_EXTRA_CHARGES,
      data: payload,
    });
    return moOtherCharges;
  }

  updateMOStatus = async (payload) => {
    const mo = await Helpers.put({
      url: Constants.MO_STATUS,
      data: payload,
    });
    return mo;
  }

  deleteMO = async (payload) => {
    const url = Constants.MO;
    const mo = await Helpers.delete({ url, data: payload });
    return mo;
  }

  archiveMo = async (payload) => {
    const url = `${Constants.MO}/archive`;
    const mo = await Helpers.post({ url, data: payload });
    return mo;
  }

  getMO = async (tenantId, moId, status, page, limit, searchKeyword, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp, source, customerId, salesOrderNumber) => {
    let url = `${Constants.MO}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (moId) url += `mo_id=${moId}&`;
    if (status) url += `status=${status}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (listScreen) url += `list_screen=${listScreen}&`;
    if (isArchived) url += `is_archived=${isArchived}&`;
    if (isWeightedAverage) url += 'is_mo_line_cost_weighted_average=true';
    if (scheduledStartDate) url += `scheduled_from_date=${dayjs(scheduledStartDate).format('YYYY-MM-DD')}&`;
    if (scheduledEndDate) url += `scheduled_to_date=${dayjs(scheduledEndDate).format('YYYY-MM-DD')}&`;
    if (isLinkedMrp) url += `is_linked_mrp=false&`;
    if (source) url += `source=${source}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    if (salesOrderNumber) url += `sales_order_number=${salesOrderNumber}&`;

    const mo = await Helpers.get({ url });

    return mo;
  }

  updateMOAdjustmentStatus = async (payload) => {
    const mo = await Helpers.put({
      url: Constants.MO_ADJUSTMENT_STATUS,
      data: payload,
    });
    return mo;
  }

  getMoJobWorks = async (payload) => {
    const moJobWorks = await Helpers.get({
      url: `${Constants.MO}/job_works?mo_id=${payload?.mo_id}`,
    });
    return moJobWorks;
  }

  getDownloadMO = async (type, emails, tenantId, status, searchKeyword, fromDate, toDate, sellerId, departmentId, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, userId,  source, customerId, salesOrderNumber) => {
    let url = `${Constants.MO}/download_manufacturing_order_list?`;
    if (type) url += `type=${type}&`;
    if (emails) url += `emails=${emails}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (status) url += `status=${status}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (isArchived) url += `is_archived=${isArchived}&`;
    if (isWeightedAverage) url += 'is_mo_line_cost_weighted_average=true&';
    if (scheduledStartDate) url += `scheduled_from_date=${dayjs(scheduledStartDate).format('YYYY-MM-DD')}&`;
    if (scheduledEndDate) url += `scheduled_to_date=${dayjs(scheduledEndDate).format('YYYY-MM-DD')}&`;
    if (userId) url += `user_id=${userId}&`;
    if (source) url += `source=${source}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    if (salesOrderNumber) url += `sales_order_number=${salesOrderNumber}&`;
    const moData = await Helpers.get({
      url,
    });
    return moData;
  }

  addRM = async (payload) => {
    const mo = await Helpers.put({
      url: `${Constants.MO}/add_adhoc_rm`,
      data: payload,
    });
    return mo;
  }

  removeRM = async (payload) => {
    const mo = await Helpers.put({
      url: `${Constants.MO}/remove_rm`,
      data: payload,
    });
    return mo;
  }

  swapRM = async (payload) => {
    const mo = await Helpers.put({
      url: `${Constants.MO}/swap_rm`,
      data: payload,
    });
    return mo;
  }

  getWorkOrderRm = async (moId, fgTenantProductId) => {
    let url = `${Constants.MO}/work_order_rms?`;
    if (moId) url += `mo_id=${moId}&`;
    if (fgTenantProductId) url += `fg_tenant_product_id=${fgTenantProductId}&`;

    const workOrderRm = await Helpers.get({ url });

    return workOrderRm;
  }
}
export default new MOServices();
